import { useEffect, useRef } from "react";
import { getTargetElement } from "./get-target-element";
/**
 * mutation observer hook
 * @param {*} callback
 * @param {*} target
 * @param {*} options
 */

var useMutationObserver = function (callback, target, options) {
  if (options === void 0) {
    options = {};
  }

  var callbackRef = useRef(callback);
  useEffect(function () {
    var _a;

    var element = getTargetElement(target);
    var observer;

    if (element) {
      observer = new MutationObserver(callbackRef.current);
      (_a = observer === null || observer === void 0 ? void 0 : observer.observe) === null || _a === void 0 ? void 0 : _a.call(observer, element, options);
    }

    return function () {
      var _a;

      if (observer) {
        (_a = observer === null || observer === void 0 ? void 0 : observer.disconnect) === null || _a === void 0 ? void 0 : _a.call(observer);
      }
    };
  }, [target]);
};

export { useMutationObserver };